<template>
	<div
		class="panel announces"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<div class="row align-items-end">
					<div class="col-12 col-lg-12">
						<h2>
							{{ block.block_title }}
						</h2>
					</div>
				</div>
			</div>
			<ul class="announce_list">
				<li v-for="(item, index) in this.block.items" :key="index" class="row">
					<div class="col-12 col-sm-4 col-lg-2">
						<div v-if="item.date" class="announce_date_block">
							<div class="row">
								<div class="d-none d-lg-flex col col-sm-12">
									<div class="announce_date_year mb-3">
										{{ item.date | moment('YYYY') }}
									</div>
								</div>
								<div class="col col-sm-12">
									<div class="announce_date_day justify-content-start">
										<span>{{ item.date | moment('D') }}</span>
									</div>
								</div>
								<div class="col col-sm-12">
									<div class="announce_date_properties justify-content-start">
										<div class="announce_date_month">
											{{ item.date | moment('MMMM') }}
										</div>
										<div class="announce_date_weekday">
											{{ item.date |moment('HH:mm') }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-8 col-lg-4">
						<div class="announce_image_block">
							<b-img-lazy :src="item.image.src" :alt="item.description" class="" />
						</div>
					</div>
					<div data-v-01a8bc6f="" class="col-12 col-lg-6" data-v-f3f3ccdc="">
						<div data-v-01a8bc6f="" class="announce_content_block" data-v-f3f3ccdc="">
							<div class="announce_content_middle">
								<a target="_blank" :href="item.url" class="title announce_title">
									{{ item.title }}
								</a>
								<p class="description">
									{{ item.description }}
								</p>
							</div>
							<div class="announce_content_footer">
								<a target="_blank" :href="item.url" class="more_link">
									{{ item.url_title }}
								</a>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import moment from '@/utils/moment';
import panel from '~/mixins/panel';

export default {
	name: 'PanelTi04',
	mixins: [panel],
	props: ['block'],
	created() {
		moment.locale(this.$i18n.locale);
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-announces";
</style>
